import { connect } from 'react-refetch';
import 'isomorphic-fetch';

export const glossaryConnect = Component =>
  connect(() => ({
    glossaryFetch: '/identity-glossary/api/terms'
  }))(Component);

export const termDetailConnect = Component =>
  connect(props => ({
    termDetailFetch: `/identity-glossary/api/${props.route}`
  }))(Component);

export default {
  glossaryConnect,
  termDetailConnect
};



// WEBPACK FOOTER //
// ./src/pages/identity-glossary/connect.js